import OrderTotals from '../promo/OrderTotals';
import React, { useRef, useState } from 'react';
import { calculatePrice, formatPrice } from '../../utils/utils';
import { productImagePaths } from '../../utils/productImages';
import OrderAvailabilityBadges from '../OrderAvailabilityBadges';
import PreOrderBlock from '../PreOrderBlock';
import ProductPhoto from '../ProductPhoto';
import '../../styles/checkout-products.css';

const PREVIEW_COUNT = 3;

const CheckoutProductList = ({
  products,
  showAvailability = false,
  renderPromCommissionBlock,
  forceExpanded = false,
  promoQuote,
  renderPromoInput,
}) => {
  const [expanded, setExpanded] = useState(false);
  const listRef = useRef(null);
  const showAll = expanded || forceExpanded;
  const visibleProducts = showAll ? products : products.slice(0, PREVIEW_COUNT);
  const hiddenCount = products.length - PREVIEW_COUNT;
  const { totalPrice, discountedPrice } = calculatePrice({ products });
  const finalTotal = promoQuote?.finalTotal ?? discountedPrice;

  const toggleExpanded = () => {
    if (expanded && listRef.current.getBoundingClientRect().top < 0) {
      listRef.current.scrollIntoView({ block: 'start' });
    }
    setExpanded(value => !value);
  };

  return <div className='checkout-products' ref={listRef}>
    <ul className='checkout-products-list'>
      {visibleProducts.map((product, index) => {
        const price = product.discountedPrice ?? product.price;
        const image = productImagePaths(product)[0];
        return <li key={product.id} className='checkout-product'>
          <div className='checkout-product-heading'>
            <ProductPhoto image={image} name={product.name} price={product.price}
              personalDiscount={product.personalDiscount} productDiscount={product.productDiscount}
              discountedPrice={product.discountedPrice} className='checkout-product-image' />
            <h6 className='checkout-product-name'>{product.name}</h6>
          </div>
          <div className='checkout-product-availability'>
            {showAvailability ? <OrderAvailabilityBadges product={product} />
              : product.state === 'PREORDER' && <PreOrderBlock expectedArrivalDate={product.expectedArrivalDate} className='mt-1' />}
          </div>
          <div className='checkout-product-prices'>
            <span className='checkout-product-unit-price'>
              <span>{product.quantity} шт. ×</span>
              {price < product.price && <del className='checkout-product-old-price'>
                {formatPrice(product.price)} грн
              </del>}
              <span>{formatPrice(price)} грн</span>
            </span>
            <strong className='checkout-product-total'>{formatPrice(price * product.quantity)} грн</strong>
          </div>
          {renderPromCommissionBlock && renderPromCommissionBlock(index)}
        </li>;
      })}
    </ul>
    {hiddenCount > 0 && !forceExpanded && <button type='button'
      className='checkout-products-toggle' aria-expanded={expanded}
      onClick={toggleExpanded}>
      {expanded ? 'Згорнути' : `Показати всі товари (${products.length})`}
      <i className={`bi bi-chevron-${expanded ? 'up' : 'down'}`} aria-hidden='true' />
    </button>}
    {renderPromoInput && renderPromoInput()}
    <OrderTotals totalPrice={totalPrice} finalTotal={finalTotal} promo={promoQuote} />
  </div>;
};

export default CheckoutProductList;
